/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddCarrierSignificantEventResponse
 */
export interface AddCarrierSignificantEventResponse {
  /**
   *
   * @type {string}
   * @memberof AddCarrierSignificantEventResponse
   */
  carrierSignificantEventId: string;
}

/**
 * Check if a given object implements the AddCarrierSignificantEventResponse interface.
 */
export function instanceOfAddCarrierSignificantEventResponse(
  value: object,
): value is AddCarrierSignificantEventResponse {
  if (
    !("carrierSignificantEventId" in value) ||
    value["carrierSignificantEventId"] === undefined
  )
    return false;
  return true;
}

export function AddCarrierSignificantEventResponseFromJSON(
  json: any,
): AddCarrierSignificantEventResponse {
  return AddCarrierSignificantEventResponseFromJSONTyped(json, false);
}

export function AddCarrierSignificantEventResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCarrierSignificantEventResponse {
  if (json == null) {
    return json;
  }
  return {
    carrierSignificantEventId: json["carrierSignificantEventId"],
  };
}

export function AddCarrierSignificantEventResponseToJSON(
  json: any,
): AddCarrierSignificantEventResponse {
  return AddCarrierSignificantEventResponseToJSONTyped(json, false);
}

export function AddCarrierSignificantEventResponseToJSONTyped(
  value?: AddCarrierSignificantEventResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierSignificantEventId: value["carrierSignificantEventId"],
  };
}
